import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { Expense } from '@/lib/types';

export interface ExpenseInput {
  category?: string;
  description: string;
  amount: number;
  expenseDate?: string;
  paymentMethod?: string;
  paidAmount?: number;
}

export async function listExpenses(
  shopId: number | string
): Promise<Expense[]> {
  const res = await apiClient.get<{ data: any[] }>(
    API_ENDPOINTS.expenses.LIST(shopId),
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function createExpense(
  shopId: number | string,
  input: ExpenseInput
): Promise<Expense> {
  const res = await apiClient.post<{ data: any }>(
    API_ENDPOINTS.expenses.CREATE(shopId),
    input,
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function updateExpense(
  shopId: number | string,
  id: number | string,
  input: ExpenseInput
): Promise<Expense> {
  const res = await apiClient.put<{ data: any }>(
    API_ENDPOINTS.expenses.UPDATE(shopId, id),
    input,
    { headers: APIHeadersWithAuth() }
  );
  return res.data;
}

export async function deleteExpense(
  shopId: number | string,
  id: number | string
): Promise<void> {
  await apiClient.delete(API_ENDPOINTS.expenses.DELETE(shopId, id), {
    headers: APIHeadersWithAuth(),
  });
}
